import { BaseModel } from "sjs-base-model";
import RichiestaDatiAnagraficiIndirizzoRequestModel from "./RichiestaDatiAnagraficiIndirizzoRequestModel";
import RichiestaDatiAnagraficiComuneViewModel from "./RichiestaDatiAnagraficiComuneViewModel";
import AmministrazioneModel from "stores/lookup/models/AmministrazioneModel";
import RichiestaRecapitoModel from "./RichiestaRecapitoModel";
import ModalitaErogazioneModel from "stores/lookup/models/ModalitaErogazioneModel";
import TipologiaPensioneModel from "stores/lookup/models/TipologiaPensioneModel";
import CategoriaAmministrativaModel from "stores/lookup/models/CategoriaAmministrativaModel";
export default class RichiestaDatiAnagraficiRequestModel extends BaseModel {
    public readonly nome: string = "";
    public readonly cognome: string = "";
    public readonly dataNascita?: string = undefined;
    public readonly sesso: string = "";
    public readonly codiceFiscale: string = "";
    public readonly nazioneNascita: string = "";
    public readonly luogoNascitaEstero: string = "";
    public readonly comuneNascita?: RichiestaDatiAnagraficiComuneViewModel = undefined;
    public readonly cittadinanza: string = "";
    public readonly altraCittadinanza?: string = undefined;
    public readonly tipoDocumento: string = "";
    public readonly numeroDocumento: string = "";
    public readonly luogoRilascio?: RichiestaDatiAnagraficiComuneViewModel = undefined;
    public readonly dataRilascioDoc?: string = undefined;
    public readonly dataScadenzaDoc?: string = undefined;
    public readonly indirizzoResidenza?: RichiestaDatiAnagraficiIndirizzoRequestModel = undefined;
    public readonly indirizzoDomicilio?: RichiestaDatiAnagraficiIndirizzoRequestModel = undefined;
    public readonly indirizzoCorrispondenza?: RichiestaDatiAnagraficiIndirizzoRequestModel = undefined;
    public readonly recapitoTelefonico?: RichiestaRecapitoModel = undefined;
    public readonly amministrazione?: AmministrazioneModel = undefined;
    public readonly dataAssunzione?: string = undefined;
    public readonly codTipoRichiedente: string = "";
    public readonly idRichiesta?: number = 0;
    public readonly isSospensione?: boolean = false;
    public readonly step?: string = "";
    public readonly modalitaErogazione?: ModalitaErogazioneModel = undefined;
    public readonly iban: string = "";
    public readonly dataScadenzaContrattoDeterminato?: string = undefined;
    public readonly isDeterminato: boolean = false;
    public readonly isIndeterminato: boolean = false;
    public readonly tipologiaPensioneAltro: string = "";
    public readonly isCointestata: boolean = false;
    public readonly dataAccensioneContoCorrente?: string = undefined;
    public readonly isDocumentazioneBancaria: boolean = false;
    public readonly isBustaPaga: boolean = false;
    public readonly isAltroBonifico: boolean = false;
    public readonly rilevazioneCoordinateAltro: string = "";
    public readonly isMeMedesimo: boolean = false;
    public readonly isContoCointestato: boolean = false;
    public readonly nominativoCointestatario: string = "";
    public readonly gradoParentelaCointestatario: string = "";
    public readonly banca: string = "";
    public readonly sportello: string = "";
    public readonly isOrdinario: boolean = false;
    public readonly isOnline: boolean = false;
    public readonly isCartaPrepagata: boolean = false;
    public readonly tipologiaPensione?: TipologiaPensioneModel = undefined;
    public readonly isTipologiaPensione: boolean = false;
    public readonly categoriaAmministrativa?: CategoriaAmministrativaModel = undefined;
    public readonly isAffitto: boolean = false;
    public readonly isProprieta: boolean = false;
    public readonly isTerzi: boolean = false;
    public readonly isFamiglia: boolean = false;

    // campo non necessario
    //  public readonly qualifica?: QualificaModel = undefined;
    //  public readonly descrizioneQualifica?: string = undefined;

    constructor(data: Partial<RichiestaDatiAnagraficiRequestModel>) {
        super();

        this.update(data);
    }
}
